"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CornerstoneForm = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneForm"));
var _CornerstoneRow = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneRow"));
var _CornerstoneCard = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneCard"));
var _CornerstoneButton = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneButton"));
var _CornerstoneModal = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneModal"));
var _DraggableTitle = _interopRequireDefault(require("../DraggableTitle/DraggableTitle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class Persona extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onCloseModal", () => {
      this.props.onCancel();
    });
    this.state = {};
  }
  render() {
    let superUserList = [];
    if (JSON.parse(sessionStorage.getItem("userPersonaObj")) && JSON.parse(sessionStorage.getItem("userPersonaObj")).superUserList && JSON.parse(sessionStorage.getItem("userPersonaObj")).superUserList.length && localStorage.getItem("AppId") === "PDS") {
      superUserList = JSON.parse(sessionStorage.getItem("userPersonaObj")).superUserList;
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CornerstoneModal.default, {
      title: /*#__PURE__*/_react.default.createElement(_DraggableTitle.default, {
        title: "My Persona"
      }),
      width: "50%",
      visible: this.props.openMyPersona,
      onCancel: this.onCloseModal,
      footer: null,
      maskClosable: false
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default, null, /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-2"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      key: "pdsp",
      label: "PDS Persona(s)"
    })), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      sm: 1
    }), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, null, /*#__PURE__*/_react.default.createElement(_CornerstoneCard.default, {
      sm: 1
    }, this.props.userPersonaList ? this.props.userPersonaList.map(obj => {
      return /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
        className: "mt-1",
        type: "default",
        style: {
          borderColor: "grey",
          color: "black",
          marginRight: ".5rem"
        }
      }, Object.values(obj)[1]);
    }) : null)), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, null), superUserList && superUserList.length ? /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-4"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      key: "surs",
      label: "Super User Rights",
      style: {
        color: "black"
      }
    }, superUserList && superUserList.length ? superUserList.join(", ") : null)) : null)));
  }
}
var _default = exports.default = _CornerstoneForm.default.create({
  name: "Persona"
})(Persona);